import { render, staticRenderFns } from "./JointDetails.vue?vue&type=template&id=87457efc&scoped=true&"
import script from "./JointDetails.vue?vue&type=script&lang=js&"
export * from "./JointDetails.vue?vue&type=script&lang=js&"
import style0 from "./JointDetails.vue?vue&type=style&index=0&id=87457efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87457efc",
  null
  
)

export default component.exports